import { render, staticRenderFns } from "./LandingEditor.vue?vue&type=template&id=2327eeca&scoped=true"
import script from "./LandingEditor.vue?vue&type=script&lang=js"
export * from "./LandingEditor.vue?vue&type=script&lang=js"
import style0 from "./LandingEditor.vue?vue&type=style&index=0&id=2327eeca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2327eeca",
  null
  
)

export default component.exports